import AppDetailLayout from './AppDetailLayout';
import type { AppDetailLayoutProps } from './types';

export default AppDetailLayout;
export type { AppDetailLayoutProps };
